import React from "react";
import { Modal } from "antd";

type StartupModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const MODAL_STORAGE_KEY = "startup_modal_seen_v1";

const StartupModal = ({ isOpen, onClose }: StartupModalProps) => {
  const handleClose = (): void => {
    window.localStorage.setItem(MODAL_STORAGE_KEY, "true");
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      centered
      maskClosable={false}
      wrapClassName="startup-modal"
    >
      <div className="startup-modal__card">
        <div className="startup-modal__accent" />

        <div className="startup-modal__content">
          <div className="startup-modal__badge">Announcement</div>

          <h3 className="startup-modal__title">Something New Is Coming to SooKee Rewards!</h3>

          <p className="startup-modal__text">
            The <strong>2025 SooKee Rewards Program</strong> has now come to a close. We are so grateful for your
            continuous support and loyalty to ZIC.
          </p>

          <div className="startup-modal__info">
            <p className="startup-modal__infoTitle">We’re working on what’s next</p>
            <p className="startup-modal__infoText">
              We’re currently busy crafting a new and more exciting program designed just for you. Stay tuned for
              further updates!
            </p>
          </div>

          <div className="startup-modal__actions">
            <button type="button" className="startup-modal__primaryBtn" onClick={handleClose}>
              Got it
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StartupModal;

// export this so Config can reuse the same key for "open once" logic
export const startupModalStorageKey = MODAL_STORAGE_KEY;
